export enum ConferenceActionEvent {
  boot = 'bootObj',
  add = 'add',
  modify = 'modify',
  delete = 'del'
}